import { noop } from 'lodash';
import React from 'react';
import { MetricsProvider, withCustomMetrics } from '@zocdoc/frontend-metrics';
import { SignInFormContainer } from './SignInFormContainer';
export {
    SIGN_IN_FAILURE,
    SIGN_IN_START,
    SIGN_IN_SUCCESS,
    SIGN_IN_LOCKED_USER,
} from './signInFormActions';
export { signInFormReducer } from './signInFormReducer';

const SignInFormWithoutMetric = (props) => {
    return (
        <MetricsProvider sendMetric={noop}>
            <SignInFormWithMetric {...props} />
        </MetricsProvider>
    );
};

const SignInFormWithMetric = withCustomMetrics({
    component: 'SignInForm',
})(SignInFormContainer);

export { SignInFormWithoutMetric as SignInForm, SignInFormWithMetric };
